<script setup lang="ts">
  import { Typo, TypoVariant, Picture } from '@travelata-libs/ui-kit';
  import SerpFilterGroup from './SerpFilterGroup.vue';
  import { SERP_FILTERS_TEXTS } from '../config/texts';
  import type { SerpFilterGroupId, SerpOptionsFilterGroupView } from '../model/types';
  import { useSerpFilters } from '../model/useSerpFilters';

  interface EmiratesFilterProps {
    group: SerpOptionsFilterGroupView;
  }

  defineProps<EmiratesFilterProps>();

  const { toggle, clearGroup } = useSerpFilters();

  const onSelect = (groupId: SerpFilterGroupId, key: string): void => {
    toggle(groupId, key);
  };

  const onReset = (groupId: SerpFilterGroupId): void => {
    clearGroup(groupId);
  };
</script>

<template>
  <SerpFilterGroup
    class="emirates-filter"
    :group="group"
    @select="onSelect"
    @reset="onReset"
  >
    <template #option-label>
      <span class="emirates-filter__label">
        <Typo
          :variant="TypoVariant.BodyLRegular"
          tag="span"
        >
          {{ SERP_FILTERS_TEXTS.emiratesLabel }}
        </Typo>
        <Picture
          path="travelata/emirates-red.svg"
          :lazy="false"
          :extensions="[]"
          :high-resolution="false"
          fit="contain"
          class="emirates-filter__icon"
        />
      </span>
    </template>
  </SerpFilterGroup>
</template>

<style scoped lang="scss">
  .emirates-filter {
    &__label {
      align-items: center;
      display: inline-flex;
      gap: var(--spacing-xxs);
    }

    &__icon {
      height: 14px;
      margin-left: var(--spacing-xxxs);
      width: 70px;
    }
  }
</style>
